import './index.scss'
import {setApi} from '@asocial/fe-utils'
import {lazy, useEffect, useState} from 'react'
import {currentMirror} from 'shared/mirrors/config'
import {useImgLoad} from 'shared/mirrors/img'
import {useTextLoad} from 'shared/mirrors/text'
import {withProviders} from './providers'
// inti styles
import(`shared/mirrors/${currentMirror}/styles/vars.scss`)
import(`shared/mirrors/${currentMirror}/styles/typography.scss`)

const Routing = lazy(() => import('../pages'))

const STAGE_API = 'https://gochatty.asocial-team.com/api'

function App() {
  const [isSetApi, setIsSetApi] = useState(false)
  const isLoadText = useTextLoad()
  const isLoadImage = useImgLoad()

  useEffect(() => {
    if (isSetApi) return

    setApi(process.env.NODE_ENV === 'development' ? STAGE_API : window.location.origin + '/api')
      .finally(() => setIsSetApi(true))
  }, [])

  if (!isSetApi || !isLoadText || !isLoadImage) return <></>

  return (
    <Routing />
  )
}

export default withProviders(App)
